import styled from 'styled-components';
import { Label } from '../../common/baseComponents'
import { SIZE, LAYERS } from '../../common/sizes';
import { Link } from 'react-router-dom';
import { LABEL, LIST } from '../../common/base';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const IconContainer = styled.div`    
    display: flex;     
    justify-content: center;
    margin-left:10px;
    width: 20px;
    height: 20px;
`
export const LabelContainer = styled.div`    
    margin-left: 18px;
`

export const MenuContainer = styled.nav`
    user-select: none;
    overflow-x: hidden;
    width:100%;
    padding: 0px 7px 0px 7px;
`
export const MenuSectionItemContainer = styled.li`
    display: flex;
    flex-flow: column;
    width:100%;
    margin-top: ${SIZE.THREE}px;
`

export const SectionTitle = styled(LABEL)`
    display: flex;
    margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px ${SIZE.HALF}px;
    transition: all 0.25s;
    opacity: 0;
    font-size: 16px;
`
export const SectionMenuItemsContainer = styled(LIST)`
`


export const MenuButtonContainer = styled.div`
`


export const MenuItemLabel = styled(LABEL)`
    font-size: 16px;
    transition: all 0.25s;
    white-space: nowrap;
`;

export interface MenuListItemContainerProps {
    isSelected: boolean
    isLocked: boolean
    collapse?: boolean
    isChildren?: boolean
}
export const MenuListItemContainer = styled.li<MenuListItemContainerProps>`
    display: flex;
    position: relative;
    text-decoration: none;
    width: 100%;
    align-items: center;
    justify-content:  ${(props: MenuListItemContainerProps) => !props.isChildren ? "" : "start"};
    height: fit-content;
    min-height: ${SIZE.THREE}px;
    min-width: ${SIZE.SIX}px;
    padding: ${SIZE.ONE}px 0 ${SIZE.ONE}px 0;
    background-color: ${(props: MenuListItemContainerProps) => props.isSelected ? "#122442" : "transparent"};
    ${(props: MenuListItemContainerProps) => !props.isLocked ? "&:hover {background-color: #4da0ff;}; cursor:pointer;" : "cursor:auto;"};        
    border-radius: ${(props: MenuListItemContainerProps) => (!props.collapse ? '5px' : '5px 0 0 5px')};
    margin-bottom: 4px;
    ${Label} {
        color: ${(props: MenuListItemContainerProps) => props.isSelected ? "#fff" : "#fff"};
        
        font-family: Lato;
        font-size: ${SIZE.TWO}px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        display: flex;
        align-items: center;

        word-wrap: ${(props: MenuListItemContainerProps) => (!props.collapse ? 'break-word' : 'unset')};
        min-width: ${(props: MenuListItemContainerProps) => (!props.collapse ? '197px' : '0')};
        display: ${(props: MenuListItemContainerProps) => (!props.collapse ? 'block' : 'none')};
    }
`

export const SectionBar = styled.div`
    border-bottom: 1px solid #204078;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`

export const MenuSectionsContainer = styled(LIST)`
    width: ${SIZE.SIX}px;
    height: 100%;
    text-align: left;
    transition: all 0.25s;
    box-shadow: 0 2px 4px 0 rgba(98,98,98,0.15);
    width: ${SIZE.THIRTY_SEVEN} px;
    z-index: ${LAYERS.LAYER_5};
`

export const StyledLink = styled(Link)`
    text-decoration: none;    
`

export const MenuItemChildren = styled.div`
${Label} {
    margin-left: ${SIZE.FIVE}px;
}
`

export interface SubMenuProps {
    collapse: boolean
}
export const SubMenu = styled.div`
    position: absolute;
    left: ${(props: SubMenuProps) => props.collapse ? "53px" : "260px"};
    background-color: #112240;
    width: 181px;
    border-radius: 0px 10px 10px 0px;
    padding: 13px 13px;
    z-index: 200;
    top: 60px;
`;

export const SubMenuTitle = styled.div`
    margin: 7px 0px 20px 10px;
    font-family: Lato;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #4da0ff;
`;

export interface RotateIconProps {
    isSelected: boolean
}
export const RotateIcon = styled.div`
    margin-right: ${SIZE.ONE}px;
    transition: transform 0.4s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${(props: RotateIconProps) => !props.isSelected ? `rotate(270deg)` : `rotate(90deg)`};
`




export const IconErrorSyncContainer = styled.div`
    margin: 0px 0px 0px 10px;
    flex: 1;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 8px;
`;

export const ToolTipContainer = styled.div`
    position: fixed;    
    z-index: 400;
    display: none;
    margin: -20px 0px 0px 30px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
    
    ${IconErrorSyncContainer}:hover & {
        display: flex;
    }
`;

export const ToolTipLabel = styled.div`
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  max-width:195px;
  white-space:normal;
`;